import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { getRoute, ROUTE_PARTS } from '@/router/constants';
import useSubscriptionStore from '@/store/subscription';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheNav',
  props: {
    jobCount: {},
    equipCount: {}
  },
  setup(__props: any) {

const JOBS_LINK = getRoute(ROUTE_PARTS.JOBS);
const EQUIPMENT_LINK = getRoute(ROUTE_PARTS.EQUIPMENT);
const DASHBOARD_LINK = getRoute(ROUTE_PARTS.DASHBOARD);
const ASSETS_LINK = getRoute(ROUTE_PARTS.ASSETS);
const VEHICLES_LINK = getRoute(ROUTE_PARTS.VEHICLES);



const subNavActiveMap = ref(new Map<string, boolean>());
const subscriptionStore = useSubscriptionStore();
const { isAssetsEnabled } = storeToRefs(subscriptionStore);

const isSubNavActive = (name: string) => subNavActiveMap.value.get(name);
const enableSubNav = (name: string) => {
  subNavActiveMap.value.set(name, true);
};
const disableSubNav = (name: string) => {
  subNavActiveMap.value.set(name, false);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(["nav-link", { 'nav-link--active': _ctx.$route.path.startsWith(_unref(JOBS_LINK)) }]),
      to: _unref(JOBS_LINK)
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Jobs (" + _toDisplayString(_ctx.jobCount) + ") ", 1)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_component_router_link, {
      class: _normalizeClass(["nav-link", { 'nav-link--active': _ctx.$route.path.startsWith(_unref(EQUIPMENT_LINK)) }]),
      to: _unref(EQUIPMENT_LINK)
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Equipment (" + _toDisplayString(_ctx.equipCount) + ") ", 1)
      ]),
      _: 1
    }, 8, ["class", "to"]),
    (_unref(isAssetsEnabled))
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 0,
          class: _normalizeClass(["nav-link nav-submenu", {
        'nav-link--enabled': isSubNavActive('asset'),
        'nav-link--active': _ctx.$route.path.startsWith(_unref(ASSETS_LINK)) || _ctx.$route.path.startsWith(_unref(VEHICLES_LINK)),
      }]),
          label: "ASSET MANAGER",
          "icon-right": "keyboard_arrow_up"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_menu, {
              class: "submenu-menu",
              onBeforeShow: _cache[0] || (_cache[0] = ($event: any) => (enableSubNav('asset'))),
              onBeforeHide: _cache[1] || (_cache[1] = ($event: any) => (disableSubNav('asset'))),
              "auto-close": "",
              fit: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item, { clickable: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "nav-link",
                              to: _unref(ASSETS_LINK)
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("Tagged Assets")
                              ])),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item, { clickable: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              class: "nav-link",
                              to: _unref(VEHICLES_LINK)
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("Vehicle History")
                              ])),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: _normalizeClass(["nav-link", { 'nav-link--active': _ctx.$route.fullPath === _unref(ASSETS_LINK) }]),
          to: _unref(ASSETS_LINK)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Asset Manager ")
          ])),
          _: 1
        }, 8, ["class", "to"])),
    (_unref(isAssetsEnabled))
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          class: _normalizeClass(["nav-link", { 'nav-link--active': _ctx.$route.path.startsWith(_unref(DASHBOARD_LINK)) }]),
          to: _unref(DASHBOARD_LINK)
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Dashboard ")
          ])),
          _: 1
        }, 8, ["class", "to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})